import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';


@Component({
  standalone: true,
  selector: 'rpe-nsm1',
  templateUrl: './rpe-nsm1.component.html',
  styleUrl: './rpe-nsm1.component.scss',
  imports: [
    ReactiveFormsModule, // Ensure ReactiveFormsModule is imported
  ],
})
export class RpeNsm1Component {

  m1Form: FormGroup = this.builder.group({
    kVal: ['', [Validators.required]],
    m1Val: ['', [Validators.required]],
  });

  
  constructor(private builder: FormBuilder) { }
  ngOnInit(): void {
    this.m1Form = this.builder.group({
    kVal: ['', [
            Validators.required,
            ]],
    m1Val: ['', [
            Validators.required,
            ]]
    });
  }

  onSubmit() {

  }


}
